// Libraries
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Formats a date to the UTC time zone in the specified format.
 *
 * @function
 *
 * @param {Date | string} date - The date to format. It can be a Date object or a string representing a date.
 * @param {string} format - The format. Is optional, defaults to 'MMM do yyyy'.
 * @returns {string} The formatted date in the 'MMM do yyyy' format.
 */

//TODO: Check if we can change it, it seems its overlapping function: stringDateToTime
export const formatDateToUtc = (date: Date | string, format = 'MMM d, yyyy') =>
  formatInTimeZone(new Date(date), 'UTC', format);
